(ns ui.view.card.counterparty-diligence-progress.event
  (:require
   [re-frame.core :as rf]
   [frontend.controller.websocket.event :as ws]
   [potpuri.core :as p]
   [ui.view.card.model :as common-model]
   [ui.view.card.counterparty-diligence-progress.model :as model]
   [ui.view.counterparty-diligence.responder-form.event :as responder-form-event]
   [ui.view.card.event :as common-event]
   [common.util :as cu]
   [common.schema.entities.counterparty-diligence.templates.registry :as cd-template-registry]))

(rf/reg-event-db
 ::open-change-status-confirmation-modal
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx} new-status]]
   (-> db
       (assoc-in (model/change-to-status-full-path card-state-path) new-status)
       (assoc-in (model/change-status-confirmation-modal-open-full-path card-state-path) true))))

(rf/reg-event-db
 ::close-change-status-confirmation-modal
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx}]]
   (-> db
       (p/dissoc-in (model/change-to-status-full-path card-state-path))
       (p/dissoc-in (model/submitting-status-change-full-path card-state-path))
       (p/dissoc-in (model/change-status-confirmation-modal-open-full-path card-state-path)))))

(rf/reg-event-db
 ::open-change-status-error-modal
 [rf/trim-v]
 (fn [db [{:keys [card-state-path]} error-kw]]
   (-> db
       (assoc-in (model/change-status-error-modal-open-full-path card-state-path) true)
       (assoc-in (model/change-status-error-kw-full-path card-state-path) (or error-kw :unknown-error)))))

(rf/reg-event-db
 ::close-change-status-error-modal
 [rf/trim-v]
 (fn [db [{:keys [card-state-path]}]]
   (-> db
       (p/dissoc-in (model/change-status-error-modal-open-full-path card-state-path))
       (p/dissoc-in (model/change-status-error-kw-full-path card-state-path)))))

(rf/reg-event-fx
 ::change-process-status-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx} resp]]
   (let [entities (-> resp
                      :body
                      :entities)
         entities-by-id (p/index-by :db/id entities)]
     (js/console.log "Change process status success!! " resp)
     {:db (-> db
              (common-model/merge-entities card-state-path entities-by-id))
      :fx [[:dispatch [::close-change-status-confirmation-modal ctx]]]})))

(rf/reg-event-fx
 ::change-process-status-error
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [_card-state-path] :as ctx} resp]]
   (js/console.log "Change process status error " resp)
   (let []
     {:db db
      :fx [[:dispatch [::close-change-status-confirmation-modal ctx]]
           [:dispatch [::open-change-status-error-modal ctx]]]})))

(rf/reg-event-fx
 ::change-process-status
 [rf/trim-v]
 (fn [_cofx [ctx {:keys [process-id status]}]]
   {::ws/send {:id :counterparty-diligence-process/change-process-status
               :body {:process-id process-id
                      :status status}
               :on-success [::change-process-status-success ctx]
               :on-error [::change-process-status-error ctx]}}))

(rf/reg-event-fx
 ::change-e-sign-status-success
 [rf/trim-v]
 (fn [_ctx [ctx resp]]
   (js/console.log "Change to esign " resp)
   {:fx [[:dispatch [::common-event/fetch-card-data ctx]]
         [:dispatch [::close-change-status-confirmation-modal ctx]]]}))

(rf/reg-event-fx
 ::change-e-sign-status-error
 [rf/trim-v]
 (fn [_ctx [ctx resp]]
   (js/console.log "Change to esign FAIL " resp)
   (let [message (get-in resp [:body :message])
         starting-esign-process-failed? (= message "starting-esign-process-failed")
         error-kw (if starting-esign-process-failed?
                    :starting-esign-process-failed
                    :unknown-error)]
     (js/console.log "Starting esign failed? " starting-esign-process-failed?)
     {:fx [[:dispatch [::close-change-status-confirmation-modal ctx]]
           [:dispatch [::open-change-status-error-modal ctx error-kw]]
           [:dispatch [::common-event/fetch-card-data ctx]]]})))

(rf/reg-event-fx
 ::submit-confirm-status-change
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx}]]
   (let [entities (common-model/get-entities db card-state-path)
         process (->> entities
                      vals
                      (cu/only-entity :entity.type/counterparty-diligence-process)
                      (sort-by :common/created-on)
                      last)
         process-id (:db/id process)

         new-status (get-in db (model/change-to-status-full-path card-state-path))

         new-db (assoc-in db (model/submitting-status-change-full-path card-state-path) true)]
     (case new-status
       :counterparty-diligence-process.status/waiting-for-e-sign
       (let [answers (:counterparty-diligence-process/answers process)
             template-kw (:counterparty-diligence-process/template-kw process)
             template (cd-template-registry/get-template template-kw)]
         {:db new-db
          :fx [[::responder-form-event/upload-pdf-and-submit-form
                {:process-id process-id
                 :template template
                 :answers answers
                 :attachments entities
                 :e-signature-required? true
                 :await-for-esign-process-start? true
                 :on-success-event [::change-e-sign-status-success ctx]
                 :on-error-event [::change-e-sign-status-error ctx]}]]})

       {:db new-db
        :fx [[:dispatch [::change-process-status ctx {:process-id process-id
                                                      :status new-status}]]]}))))
